import React, { useCallback, useState } from 'react'
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { rutaImg } from '../../../hooks/useValidarImagen';


const Galeria = (props) => {
    const { images } = props?.styles
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = useCallback((event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };
    return (
        <>
            {images && images.length > 0 ?
                <>
                    <Gallery photos={images.map(x => ({
                        ...x,
                        src: rutaImg + x.src
                    }))} onClick={openLightbox} />

                    <ModalGateway>
                        {viewerIsOpen ? (
                            <Modal onClose={closeLightbox}>
                                <Carousel
                                    currentIndex={currentImage}
                                    views={images.map(x => ({
                                        ...x,
                                        src: rutaImg + x.src,
                                        srcset: x.srcSet,
                                        caption: x.title
                                    }))}
                                />
                            </Modal>
                        ) : null}
                    </ModalGateway>
                </>
                : <p> Por favor agregue imagenes </p>}
        </>
    )
}

export default Galeria